import { render, staticRenderFns } from "./npl-index.vue?vue&type=template&id=fddfbc6e&scoped=true"
import script from "./npl-index.vue?vue&type=script&lang=js"
export * from "./npl-index.vue?vue&type=script&lang=js"
import style0 from "./npl-index.vue?vue&type=style&index=0&id=fddfbc6e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fddfbc6e",
  null
  
)

export default component.exports